import BaseObject from '../../../base/base_object';

export default class GamePostMessageHandlerBase extends BaseObject {

    canExecuteAction(gameOptions, actionName, params) {
        this.throwNotImplemented('6', 'canExecuteAction');
    }

    executeAction(gameOptions, actionName, params) {
        this.throwNotImplemented('10', 'executeAction');
    }
}